/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceIpadHorizontalQuestion = createReactComponent(
  "device-ipad-horizontal-question",
  "IconDeviceIpadHorizontalQuestion",
  [
    [
      "path",
      {
        d: "M15 20h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 17h4.5", key: "svg-1" }],
    ["path", { d: "M19 22v.01", key: "svg-2" }],
    [
      "path",
      {
        d: "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483",
        key: "svg-3"
      }
    ]
  ]
);

export { IconDeviceIpadHorizontalQuestion as default };
//# sourceMappingURL=IconDeviceIpadHorizontalQuestion.js.map
